export const WhatsappIcon = ({
  className,
  size = 24,
  color,
}: {
  className?: string;
  size?: number;
  color?: string;
}): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 19.5601L1.33554 14.681C0.511417 13.2529 0.078375 11.6339 0.0791667 9.97377C0.0815417 4.7836 4.30508 0.560059 9.49446 0.560059C12.0128 0.56085 14.3767 1.54173 16.1548 3.32139C17.932 5.10106 18.9105 7.46656 18.9098 9.98248C18.9074 15.1734 14.6838 19.397 9.49446 19.397C7.91904 19.3962 6.36658 19.0011 4.99146 18.2506L0 19.5601ZM5.22262 16.5462C6.54946 17.3339 7.81612 17.8057 9.49129 17.8065C13.8043 17.8065 17.3177 14.2963 17.3201 9.98089C17.3217 5.65681 13.8249 2.15131 9.49763 2.14973C5.18146 2.14973 1.67042 5.65998 1.66883 9.97456C1.66804 11.736 2.18421 13.0549 3.05108 14.4348L2.26021 17.3228L5.22262 16.5462ZM14.2373 12.2205C14.1788 12.1224 14.022 12.0638 13.7861 11.9458C13.551 11.8279 12.3943 11.2586 12.1782 11.1803C11.9629 11.1019 11.8061 11.0623 11.6486 11.2982C11.4918 11.5334 11.0406 12.0638 10.9036 12.2205C10.7667 12.3773 10.6289 12.3971 10.3938 12.2791C10.1587 12.1611 9.40025 11.9134 8.50171 11.1114C7.80267 10.4876 7.33004 9.71727 7.19308 9.48135C7.05612 9.24623 7.17883 9.11877 7.296 9.0016C7.40208 8.89631 7.53113 8.72689 7.64908 8.58914C7.76862 8.45298 7.80742 8.35481 7.88658 8.19727C7.96496 8.04052 7.92617 7.90277 7.86679 7.78481C7.80742 7.66764 7.33717 6.50943 7.14162 6.03839C6.95004 5.58002 6.75608 5.64177 6.612 5.63464L6.16075 5.62673C6.004 5.62673 5.74908 5.68531 5.53375 5.92123C5.31842 6.15714 4.71042 6.72556 4.71042 7.88377C4.71042 9.04198 5.55354 10.1606 5.67071 10.3174C5.78867 10.4741 7.32925 12.8507 9.68921 13.8696C10.2505 14.1118 10.6891 14.2567 11.0303 14.3651C11.594 14.5441 12.107 14.5187 12.5123 14.4586C12.9643 14.3913 13.904 13.8893 14.1004 13.3399C14.2967 12.7897 14.2967 12.3187 14.2373 12.2205Z"
        fill={color}
      />
    </svg>
  );
};
